import { fetchErrors, months, weekdays } from '../strings.sv';

const status = {
  DONE: 'Klar',
  DONE_WITH_DEVIATION: 'Klar med avvikelse',
  IN_PROGRESS: 'Påbörjad',
  UNKNOWN: 'Planerad',
};

export default {
  tabSE: 'DeliveryPortal Sweden',
  tabFI: 'DeliveryPortal Finland',
  disclaimer: {
    text: 'Observera att detta inte är en bygghandling.',
    proceedButton: 'OK',
  },
  geolocation: {
    text: 'Saknar rättigheter för att visa din platsinformation. Vänligen uppdatera inställningarna i din enhet för att kunna visa din position.',
    proceedButton: 'OK',
  },
  home: 'Hem',
  location: 'Din position',
  info: 'Info',
  menu: 'Meny',
  orders: 'Ordrar',
  reportsMenu: 'Rapporter',
  reportsPanel: {
    empty: 'Inga rapporter tillgängliga.',
    filterPlaceholder: 'Filtrera rapporttyp',
    searchPlaceholder: 'Sök rapporter',
    hideCompleted: 'Dölj färdiga rapporter',
    types: {
      span: 'Stråk',
      cabinet: 'Skåp',
      manhole: 'Brunn',
      kp: 'Duktpunkt',
      hc: 'HC',
      site: 'Site',
      hub: 'Hub',
    },
  },
  reportsPopupHeader: 'Projektrapportens slutförande status',
  constructionVersion: 'Bygghandlingsversion',
  constructionExplanation:
    'Senaste version & publiceringsdatum för bygghandlingen i Duktig',
  popup: {
    spanStatus: 'Stråkstatus',
    accommodationMethod: 'Förläggningsmetod',
    permissionType: 'Tillståndstyp',
    length: 'Längd',
    expandContent: 'Expandera för mer information',
    hideExpandedContent: 'Visa mindre information',
    createReport: {
      span: 'Skapa ny rapport på stråk',
      well: 'Skapa ny rapport på brunn',
      cabinet: 'Skapa ny rapport på skåp',
    },
    updateReport: 'Ändra rapport',
    existingSpan: 'Klart (redan utfört stråk)',
    address: 'Adress',
    name: 'Namn',
    editSpans: 'Redigera stråk i rapporten',
  },
  infoPopup: {
    name: 'Namn',
    description: 'Beskrivning',
    freeText: 'Övrig information',
  },
  pointInfo: {
    multiDuct: 'Multidukt:',
    color: 'Färg:',
    label: 'Label:',
    from: 'Från:',
    duct: 'Dukt:',
    connectedTo: 'Kopplad till:',
    showMore: 'Visa mer information',
    showLess: 'Visa mindre information',
    informationLoading: 'Laddar information',
    informationMissing: 'Duktinformation saknas',
    ductRow: {
      from: 'Från',
      to: 'Till',
      name: 'Namn',
      incoming: 'Inkommande',
      outgoing: 'Utgående',
    },
  },
  sitePopup: {
    name: 'Namn',
  },
  hubPopup: {
    name: 'Namn',
  },
  permitAreaPopup: {
    CREATED: 'Skapad',
    IN_PROGRESS: 'Pågående',
    COMPLETED: 'Klar',
    APPROVED: 'Godkänd',
    ADD: 'Tillagd',
    REVISED: 'Revideras',
    WORK_DONE: 'Jobb klart',
    INSPECTION_COMPLETED: 'Inspektion avklarad',
    NOT_UTILIZED: 'Används ej',
    REVOKED: 'Återkallad',
    CLOSED_BY_TRV: 'Stängd av trv',
    MISPLACEMENT: 'Felplacering',
    EXPIRED: 'Utgånget',
    SITING_NOT_FILED: 'Plats inte arkiverat',
    SITING_PERMIT_FILED: 'Lokaliseringstillstånd lämnats in',
    SITING_PERMIT_APPROVED: 'Lokaliseringstillstånd godkänt',
    EXCAVATION_PERMIT_FILED: 'Grävtillstånd inlämnat',
    EXCAVATION_PERMIT_APPROVED: 'Grävtillstånd godkänt',
    type: 'Typ',
    name: 'Namn',
    description: 'Beskrivning',
    status: 'Status',
  },
  duct: {
    loading: 'Hämtar kanalisation',
    header: 'Kanalisation',
    missing: 'Kanalisation saknas',
    from: 'från',
    showSubducts: 'Visa alla dukter',
    hideSubducts: 'Dölj subdukter',
  },
  noResourceSelected:
    'Saknar aktivt projekt. Var god välj projekt ovan eller kontakta din administratör för ytterligare accesser.',
  mapDataError: 'Kunde inte hämta kartdatan.',
  report: {
    tab1: 'Steg 1',
    tab2: 'Steg 2',
    addReport: 'Lägg till rapport',
    report: 'Fältrapportering',
    reports: 'Fältrapporter',
    upload: 'Ladda upp bilder',
    download: 'Ladda ned',
    deviationLength: 'Den rapporterade avvikelsen är ',
    reportedLength: 'Den rapporterade längden är ',
    reportHeaders: {
      span: 'Stråk',
      length: 'Planerad stråklängd',
      accommodationMethod: 'Förläggningsmetod',
      status: 'Status',
      deviationType: 'Definiera avvikelse',
      comment: 'Kommentar',
      commentField: 'Lägg till kommentar',
      commentPlaceholder: 'Lägg till kommentar om arbetet',
      deviationTypes: 'Avvikelse',
      reportedLength: 'Avvikande längd (m)',
      deviationMethods: 'Förläggningsmetoder',
      name: 'Namn',
      requirement: 'Krav',
      objectType: 'Objekt typ',
      type: 'Typ',
      well: 'Brunn',
      slingwell: 'Brunn',
      cablewell: 'Brunn',
      cabinet: 'Skåp',
      jointpoint: 'Utskarvningspunkt',
      info: 'Informationspunkt',
      id: 'Id',
      date: 'Rapporteringsdatum',
      createdBy: 'Skapad av',
      contractorComment: 'Entreprenörens kommentar',
      criteriaReport: 'Egenkontroller',
      criteriaInfo:
        'Vänligen läs checklistan nedan och markera de punkter som har genomförts. Observera att vissa punkter kan behöva en bild eller video.',
      validationError: 'Vänligen fyll i alla obligatoriska fält',
      clear: 'Rensa',
      calculatedPlannedDeviation: 'Planerade längden är ',
      plannedDeviationText: 'Ange längden för den avvikande sträckan.',
      calculatedDeviation1: 'Längden av avvikande sträckan är ',
      calculatedDeviation2: 'Därmed ',
      calculatedDeviation3:
        'lämnas som behöver rapporteras genom att välja förläggningsmetoder. ',
      commentDeviationPlaceholder:
        'Vänligen ange information om avvikelsen här.',
    },
    statusDropdownOption: {
      inProgress: 'Påbörjad',
      done: 'Klar',
      doneWithDeviation: 'Klar med avvikelse',
      unknown: 'Okänd',
      all: 'Alla',
    },
    search: 'Sök',
    searchPlaceholder: 'Ange id',
    filterStatus: 'Filtrera efter status',
    filterType: 'Filtrera efter typ',
    status: {
      inProgress: 'Påbörjad',
      done: 'Klar',
      deviation: 'Klar med avvikelse',
    },
    invalidField: {
      deviationType: 'Vänligen välj minst en avvikelsetyp',
      comment: 'Vänligen skriv en kommentar gällande avvikelsen',
      reportedLength: 'Vänligen skriv den avvikande sträckan (i meter)',
      workPerformed: 'Vänligen lägg till minst en metod',
      totalLengthError:
        'Vänligen ändra så totala längden överensstämmer med stråklängden',
    },
    suppliedMaterial: 'Andel av stråklängd som är fall B',
    noSuppliedMaterial: 'Ej angivet',
    notSynced: 'Inte synkroniserad',
    chooseDeviation: 'Välj avvikelsetyp',
    verificationRequired:
      'Den rapporterade längden är mer än 50% över den planerade längden. Är detta korrekt?',
    methodDeviation: {
      addMethod: 'Lägg till metod',
      dropdownPlaceholder: 'Välj metod',
      totalLength: 'Total längd',
      deviationHeader: 'Avvikelse längd (m)',
      accomoodationMethod: 'Förläggningsmetod',
    },
    saveReport: 'Spara rapport',
    next: 'Nästa steg',
    dismiss: 'Avbryt',
    success: 'Rapporten har sparats!',
    offline:
      'Rapporten har sparats offline och kommer laddas upp vid nästa tillfälle appen är online.',
    error: 'Kunde inte spara rapporten. Var vänlig försök igen.',
    backToReports: 'Tillbaka till rapportlistan',
    open: 'Öppna rapport',
    create: 'Skapa rapport',
  },
  installationReport: {
    popUpBtnText: 'Progressrapportering',
    header: 'Progressrapportering',
    saveBtn: 'Spara rapport',
    addressLabel: 'Address',
    toOrdersModal: 'Till beställningsöversikt',
    confirmModal: {
      header: 'Är du säker att du vill stänga modalen?',
      text: 'Det finns osparande ändringar, se till att spara dem innan du stänger modalen.',
      cancelBtn: 'Tillbaka till rapporten',
      closeBtn: 'Stäng modalen!',
    },
    missingIdMessage: 'Progressrapportering saknar id (sourceKey)',
    saveSuccessMessage: 'Progressrapportering har sparats!',
    saveErrorMessage:
      'Kunde inte spara Progressrapportering. Var vänlig försök igen.',
    failToLoadMessage: {
      403: 'Behörighet saknas för att ladda Progressrapportering.',
      404: 'Progressrapportering i vald bostad saknas.',
      408: 'Request Timeout. Vänligen ladda om sidan.',
      500: 'Problem med servern, vänligen försök igen senare.',
      general: 'Progressrapportering kunde inte laddas.',
    },
    errorText:
      'Kunde inte ladda rapporten. Vänligen ladda om rapporten eller försök igen senare.',
    form: {
      planedInstallationDate: 'Planerad kundinstallation',
      bookedCustomerInstallationDate: 'Bokad kundinstallation',
      siteProjectPlanningExecutedDate: 'Tomtprojektering utförd',
      siteShaftBooked: 'Tomtschakt bokad',
      siteShaftInstallationDate: 'Tomtschakt utförd datum',
      fiberCableInstalledForCustomer: 'Fiber blåst hos kund',
      fiberReceiverInstallationDate: 'Installation av Fibermottagare',
      macAddress: 'MAC-adress CPE',
      email: 'Email',
      name: 'Namn',
      phoneNumber: 'Telefonnummer',
    },
  },
  installationReportV2: {
    tabNames: {
      ORDER_OVERVIEW: 'Beställningsöversikt',
      PLOT_DESIGN: 'Kundprojektering',
      PLOT_EXCAVATION: 'Tomtschakt',
      DUCT_CONNECTION: 'Dukt Koppling',
      PRE_INSTALLATION: 'Kundinstallation',
      SPLICING_MEASURING: 'Skarv & OTDR',
      SPLICING: 'Skarv',
      CABLE_BLOWING: 'Fiberblåsning',
      COMMISSIONING: 'Driftsättning',
      MEASURING: 'Mätning',
    },
    modal: {
      header: 'Installationsrapport',
      completedBy: 'Färdigställd av #{user} #{date}',
      closeBtn: 'Stäng',
      saveBtn: 'Spara',
      completeBtn: 'Färdigställ rapport',
      unlockReportBtn: 'Lås upp rapport',
      reportCompletedBtn: 'Rapport färdigställd',
      reportCompletedDisabledTooltip:
        'Kontakta din byggledare för att få rapporten upplåst.',
      completeBtnDisabledTooltip:
        'Rapporten kan färdigställas när alla faser är helt avslutade.',
      onProceedError: 'Installationsrapporten är felaktigt ifylld',
      cannotSaveNetAdmin: 'Kan inte spara NetAdmin värde.',
    },
    completeConfirmation: {
      title: 'Färdigställ rapport?',
      whatHappens: 'Vad händer om du bekräftar?',
      bulletInvoice: 'Kunden faktureras direkt efter bekräftelse.',
      bulletLocked: 'Hela rapporten låses och kan inte ändras.',
      checkboxLabel: 'Jag har läst och förstått texten ovan.',
      cancel: 'Avbryt',
      confirm: 'Bekräfta',
      completedTitle: 'Rapport färdigställd!',
      completedBody:
        'Kunden har beställts och fakturan har skickats! Denna rapport kan inte längre redigeras.',
      closeWindow: 'Stäng detta fönster',
    },
    plotDesignTab: {
      instructions: 'Fyll i informationen för att slutföra.',
      completed: 'Kundprojektering - Avklarad!',
      plannedPlotDesign: 'Planerad Kundprojektering',
      executedPlotDesign: 'Utförd Kundprojektering',
      comment: 'Kommentar',
      awaitingSign: 'Inväntar signering',
      completedSign: 'Signering avklarad',
      initiateSign: 'Påbörja signering',
    },
    plotExcavationTab: {
      instructions: 'Fyll i informationen för att slutföra.',
      completed: 'Tomtschakt - Avklarad!',
      plannedPlotExcavation: 'Planerad Tomtschakt',
      executedPlotExcavation: 'Utförd Tomtschakt',
      comment: 'Kommentar',
    },
    ductConnectionTab: {
      instructions: 'Utför egenkontroll för att slutföra Dukt Koppling',
      completed: 'Dukt Kopplad',
      executedDate: 'Utförd datum',
      notConnected: 'Ej kopplad',
      comment: 'Kommentar',
    },
    orderOverviewTab: {
      infoText:
        'Information om den vald beställning finns nedan. Fyll i rapporterna i flikarna ovan.',
      subHeader: 'Beställningsinformation',
      address: 'Adress',
      customerName: 'Kundnamn',
      email: 'Email',
      phoneNumber: 'Telefonnummer',
      connectionType: 'Anslutningstyp',
      contactedDate: 'Kund Kontaktad',
      statusReport: 'Rapportstatus',
      greenfieldIfs: 'Greenfield-IFS',
    },
    preinstallationTab: {
      instructions: 'Fyll i informationen och utför kontroll.',
      completed: 'Kundinstallation - Avklarad!',
      plannedPreinstallation: 'Planerad Kundinstallation',
      executedPreinstallation: 'Utförd Kundinstallation',
      macAddress: 'MAC-adress CPE / Serienummer',
      macAddressInputLabel:
        'MAC-adress CPE (P2P) eller Serienummer ONT (XGS-PON)',
      help: 'Hjälp',
      comment: 'Kommentar',
      netAdmin: 'NetAdmin',
      netAdminHeader: 'ONT / CPE-registrering',
      netAdminSubHeader:
        'Välj enhet och fyll i värde nedan. Spara för att registrera!',
      deviceCategory: 'Enhetstyp',
      deviceValue: 'Enhetsvärde',
      macSerialPlaceholder: 'MAC / Serienummer',
      mustMatchFormat: 'Måste matcha format:',
      netAdminStatus: {
        saveToUpload:
          'Fyll i MAC-adress CPE / Serienummer och Spara för att ladda upp!',
        notSaved: 'Ej sparad',
        cannotUpload:
          'Sparad - men kan inte ladda upp utan utfört datum och slutförda egenkontroller.',
        clickSave: 'Klicka på Spara för att ladda upp till NetAdmin!',
        uploading: 'MAC-adress CPE / Serienummer har skickats till NetAdmin!',
        uploaded: 'Uppladdad & Sparad',
      },
      inputPlaceHolder: 'MAC-address CPE eller Serienummer',
      maxInput: 'Max 17 tecken tillåtet.',
      incorrectFormat: 'Ogiltigt format, se Hjälp för instruktioner.',
      model: 'Modell',
      selection: 'Välj',
    },
    splicingAndMeasuringTab: {
      instructions: 'Fyll i informationen och ladda upp filer!',
      completed: 'Skarvning & OTDR - Avklarad!',
      plannedMeasuring: 'Planerad OTDR',
      executedMeasuring: 'Utförd OTDR',
      plannedSplicing: 'Planerad Skarvning',
      executedSplicing: 'Utförd Skarvning',
      fileAndImageUpload: 'Fil- och bilduppladdning',
      upload: 'Ladda upp',
      showImages: 'Visa bilder',
      comment: 'Kommentar',
      commentDescriptionExplanation:
        'Vänligen ange orsaken till att du inte följer panelkortet.',
      fiberData: {
        title: 'Fiberuppgifter',
        panelcard: {
          question: 'Följt Panelkortet?',
          yes: 'Ja',
          no: 'Nej',
        },
        switchName: 'Switchnamn',
        switchPort: 'Switchport',
        switchCard: 'Switchblad',
        odfInSite: 'ODF i Nod',
        odfContact: 'Kontakt i ODF',
        cabinet: 'FOS (Fiber Optiskt Skåp)',
        cableIdCabinet: 'Kabelnamn i FOS/Brunn',
        fiberInCabinet: 'Fiber i FOS',
        ductColorInCabinet: 'Ductfärg i FOS/Brunn',
        splitterPort: 'Splitterport',
        splitterName: 'Splitternamn',
        placeholders: {
          syntax: 'NNNN000-NN0',
          number: 'Nummer',
          focType: 'Ange FOS',
          focCableId: 'Ange Kabelnamn',
          color: 'Ange Duktfärg',
          name: 'Ange namn',
          select: 'Välj',
        },
        descriptions: {
          switchNameSyntax: 'Föreslaget format NNNNN0000-NN0',
        },
      },
      toast: {
        notFollowingPanelcard:
          'Ange anledningen till att du inte följer panelkortet i kommentaren.',
      },
    },
    cableBlowingTab: {
      instructions: 'Fyll i informationen för att slutföra detta moment.',
      completed: 'Fiberblåsning - Avklarad!',
      plannedCableBlowing: 'Planerad Fiberblåsning',
      executedCableBlowing: 'Utförd Fiberblåsning',
      comment: 'Kommentar',
    },
    commissioningTab: {
      instructions: 'Fyll i informationen och genomför kontrollerna.',
      completed: 'Driftsättning - Avklarad!',
      plannedCommissioning: 'Planerad Driftsättning',
      executedCommissioning: 'Utförd Driftsättning',
      plannedMeasuring: 'Planerad Mätning',
      executedMeasuring: 'Utförd Mätning',
      comment: 'Kommentar',
    },
    selfInspection: {
      markAsComplete: 'Markera som klar',
      uploadImage: 'Ladda upp bild',
      showControlled: 'Visa kontrollerade',
      undoSelfInspection: 'Ångra egenkontroll',
      handleImage: 'Hantera bilder',
      showAttachments: 'Visa bilagor',
      updateSelfInspectionErrorMessage: 'Egenkontroll kunde inte uppdateras',
      notApplicableText: 'Ange anledning',
      cancel: 'Avbryt',
      markAsNonApplicable: 'Markera som icke-applicerbar',
      notApplicable: 'Icke-applicerbar',
      editNotApplicableComment: 'Redigera beskrivning',
      saveChanges: 'Spara',
      updateSelfInspectionSuccessMessage: 'Beskrivningen är uppdaterad',
      selfInspectionSavedSuccessMessage: 'Egenkontrollen är sparad',
      revertSelfInspectionMessage: 'Egenkontrollen är ångrad',
      updateSelfInspectionFilesMessage: 'Egenkontrollens filer är updaterade',
      updateSelfInspectionRevertedMessage:
        'Uppladdningen av bilder cancellerades',
      uploadSelfInspectionImageSuccess: 'Bilder uppladdade!',
      uploadSelfInspectionImageError:
        'Kunde inte ladda upp bilder. Försök igen!',
      deleteSelfinspectionImageSuccess: 'Bilden har blivit borttagen.',
      deleteSelfinspectionImageError: 'Kunde inte ta bort bild.',
      loadingImages: 'Laddar bilder...',
      instructionalImage: {
        DepthExampleImage: 'Inkludera måttstock i bilden - Se exempel',
      },
      done: 'Klar: ',
      na: 'N/A: ',
    },
    updateInstallationReportSuccess: 'Dina ändringar är nu sparade',
    updateInstallationReportError: 'Dina ändringar kunde inte sparas',
    clearDate: 'Rensa datum',
    alerts: {
      executedDateAlert: 'Se till att alla egenkontroller är ifyllda',
      signReady: 'Redo för signering',
    },
    imageChecklist: {
      title: 'Bild-checklista',
      listItems: {
        splicingOutlet: 'Bild på skarv i fiberuttag/fasadbox',
        splicingFOS: 'Bild på skarv i FOS',
        sealingDuctFOS: 'Bild på tätning av dukt i FOS',
        hasOdfPortImage: 'Bild på ODF port',
        hasSwitchPortImage: 'Bild på Switchport',
        hasNodeImage: 'Före och efter bild i nod',
      },
    },
  },
  ...status,
  legend: {
    legendLabel: 'Teckenförklaring',
    filterLabel: 'Filter',
    spanLayer: 'Stråk',
    distpointLayer: 'Punkter',
    hc: 'HC - Hus anslutet',
    hp: 'HP - Hus passerat',
    well: 'Brunn',
    cabinet: 'Skåp',
    site: 'Site',
    hub: 'Hub',
    jointpoint: 'Utskarvningspunkt',
    info: 'Informationspunkt',
    trv: 'TRV - Tryckningspunkt',
    sdp: 'SDP - Slutduktpunkt',
    kp: 'KP - Kanalisationspunkt',
    loa: 'Markavtalsområden',
    loaDone: 'Avtal klart',
    loaRequired: 'Avtal saknas',
    permitArea: 'Tillståndsområde',
    multiHp: 'Multi-HP',
    multiHc: 'Multi-HC',
    multiHousehold: 'Multi-HP/HC',
    multiWell: 'Multi-Brunn',
    spanV2: {
      SELECTED: 'Vald & stråk i samma rapport',
      PLANNED: 'Planerad',
      IN_PROGRESS: 'Påbörjad',
      DONE: 'Klar',
      RESTORED: 'Återställd',
      DEVIATED: 'Återställd + Avvikelse',
      EXISTING: 'Befintligt',
    },
    selectAll: 'Markera alla',
  },
  definition: {
    unknown: 'Okänd',
    noTranslation: 'Översättning saknas',
  },
  projectOverview: {
    header: 'Projektöversikt',
    compileButton: 'Sammanställ',
    from: 'Från',
    to: 'Till',
    compiledData: 'Sammanställd Data',
    reportCount: 'Antal rapporter',
    totalPlannedDeviation: 'Skillnad mot planerad längd',
    totalPerformed: 'Utförd längd',
    tableHeaders: {
      method: 'Förläggningsmetod',
      plannedLengthDeviation: 'Avvikelse från planerad längd (m)',
      performedLength: 'Utfört (m)',
    },
  },
  duktsSidebar: {
    ductId: 'Dukt id',
    type: 'Kanalisation',
    color: 'Färg',
  },
  datepickerPlaceholder: 'ÅÅÅÅ-MM-DD',
  dateFormatError: 'Du har fyllt i ett felaktigt datum (ÅÅÅÅ-MM-DD).',
  tableConfiguration: {
    title: 'Anpassa tabell',
    cancel: 'Avbryt',
    apply: 'Applicera',
    showAllColumns: 'Visa alla kolumner',
  },
  fetchErrors,
  ...weekdays,
  ...months,
  rolloutProgressLabel: 'Rollout Progress',
  ducts: 'Dukter',
  subDucts: 'Subdukter',
  searchDucts: 'Namn, id eller färg',
  clear: 'Rensa',
  errorFetchingDucts: 'Kunde inte hämta dukter.',
  close: 'Stäng',
  searchDuct: 'Sök dukt',
  ordersOverview: {
    modalHeader: 'Beställningsöversikt',
    formFilterHeader: 'Filtrering',
    formFilterOrdersHeader: 'Filtrera beställningar',
    filterInputPlaceholder: 'address, kundnamn, ort..',
    mapMenuButton: 'Beställningsöversikt',
    downloadExcel: 'Ladda ned Excel',
    downloadSuccess: 'Excel-fil nedladdad',
    downloadError: 'Excel-filen kunde inte hämtas.',
    downloadPdfStarted:
      'Genererar PDF för {address}. PDF-generering kan ta ett tag beroende på rapportstorleken.',
    downloadPdfSuccess: 'PDF nedladdad',
    downloadPdf429Title: 'Vänta',
    downloadPdfError429:
      'PDF-generering är upptagen. Vänta en stund och försök igen.',
    downloadPdfErrorGeneric: 'Kunde inte generera PDF. Försök igen.',
    downloadPdfCancelled:
      'PDF-nedladdningen avbröts eftersom tabellen stängdes.',
    downloadPdfCancelledPopup:
      'PDF-nedladdningen avbröts eftersom popup-fönstret stängdes.',
    filterOptions: {
      showAll: 'Visa alla',
      incomplete: 'Visa ej färdiga',
      complete: 'Visa färdiga',
    },
    tableHeaders: {
      address: 'Adress',
      completedDate: 'Färdigställt datum',
      customerName: 'Kundnamn',
      latestStatus: 'Senaste status',
      statusDate: 'Datum för status',
      netAdminId: 'NetAdmin ID',
      customerInstallationDate: 'Installationsdatum',
      pdf: 'PDF',
      planedInstallationDate: 'Planerad kundinstallation',
      bookedCustomerInstallationDate: 'Bokad kundinstallation',
      siteProjectPlanningExecutedDate: 'Tomtprojektering utförd',
      siteShaftBooked: 'Tomtschakt bokad',
      siteShaftInstallationDate: 'Tomtschakt utförd',
      fiberCableInstalledForCustomer: 'Fiber blåst',
      fiberReceiverInstallationDate: 'Fibermottagare installerad',
      plotDesignDate: 'Kundprojektering',
      preinstallationDate: 'Kundinstallation',
      plotExcavationDate: 'Tomtschakt',
      ductConnection: 'Dukt Koppling',
      cableBlowingDate: 'Fiberblåsning',
      splicingAndMeasuringDate: 'Skarvning & OTDR',
      splicingAndMeassuringDate: 'Skarvning & OTDR',
      splicingDate: 'Skarvning',
      commissioningDate: 'Driftsättning',
      measuringDate: 'Mätning',
      macAddress: 'MAC-adress CPE',
    },
    true: 'Ja',
    false: 'Nej',
    error: 'Kunde inte hämta ordrar, vänligen försök igen senare.',
    latestStatus: {
      ORDERED: 'Beställt',
      ORDERED_FOR_BUILD: 'Lämnat till bygg',
      CANCELLED: 'Cancellerad',
      REVOKED: 'Anullerad',
      WITHDRAWN: 'Ångrad',
      ESCALATED: 'Eskalerad',
      CONSTRUCTION_DEVIATION: 'Avvikelse byggledning',
      NOT_VALIDATED: 'Ej validerad',
      WARNING: 'Varning',
      INSTALLED: 'Installerad',
      UNKNOWN: 'Okänd',
    },
    status: 'Status',
  },
  selfReportingPoints: {
    modalHeader: 'Fältrapportering',
    cancelButton: 'Stäng',
    proceedButton: 'Spara & stäng',
    unsavedChanges: 'Osparade ändringar. Spara innan stängning!',
    name: 'Namn',
    object: 'Objekt',
    uploadingFiles: 'Laddar upp bilder...',
    status: {
      header: 'Status',
      started: 'Påbörjad',
      done: 'Klar',
      doneWithDeviation: 'Klar med avvikelse',
      deviationHeader: 'Beskriv anledning',
      deviationPlaceholder: 'Kommentar...',
    },
    selfInspection: {
      header: 'Egenkontroller',
      switchHeader: 'Lägg till beskrivning',
      description:
        'Gå igenom varje punkt och se till att jobbet utförs enligt beskrivningen. Observera att vissa punkter kräver en bild medan andra kanske bara kräver ditt godkännande genom att markera kryssrutan.',
    },
    selfInspectionHeaders: {
      CABINET_ESTABLISHMENT: 'Sättning skåp',
      FIBER_OPTICS: 'Fiberarbete',
      LABELING: 'Märkning',
      MANHOLE_ESTABLISHMENT: 'Sättning brunn',
      JOINT_BOX: 'Skarvbox',
      RESTORATION: 'Återställning',
    },
    showCompleted: 'Visa kontrollerade',
    couldNotBeCompleted: 'Gick ej att genomföra',
    uploadFile: 'Bifoga',
    markComplete: 'Markera som klar',
    pdfLink: 'Öppna instruktionsbild i nytt fönster',
    addImage: 'Lägg till bild',
    undoSelfInspection: 'Ångra egenkontroll',
    addedBy: 'Tillagd av',
    alertCouldNotBeCompleted:
      'Vissa egenkontroller kunde ej genomföras. Ange anledning längst upp!',
    toastSaveSuccess: 'Dina ändringar är sparade!',
    errorPreventionSaveModal: {
      title: 'Vill du spara dina ändringar?',
      confirm: 'Ja',
      deny: 'Nej',
    },
    error: 'Ett fel uppstod, vänligen försök igen senare.',
  },

  imageThumbnail: {
    addedBy: 'Tillagd av: ',
  },
  hpReportModal: {
    modalHeader: 'Progressrapportering - HP',
    proceedButtonText: {
      create: 'Skapa',
      update: 'Uppdatera',
    },
    error: {
      noProps: 'Marker har ingen data!',
    },
    pill: {
      done: 'Klar',
      doneWithoutImages: 'Klar utan bilder',
      notDone: 'Ej klar',
      status: 'Status',
      address: 'Adress',
    },
    checkBox: 'Markera som klar',
    images: {
      uploadedFiles: 'Uppladdade bilder',
      noUploadedFiles: 'Inga uppladdade bilder',
      removeFilesButton: 'Ta bort alla',
      addFilesButton: {
        choose: 'Välj filer',
        more: 'Lägg till fler +',
      },
    },
    toolTip: {
      removeFile: 'Ta bort en fil från rapporten',
      keys: {
        fileName: 'Filnamn',
        size: 'Storlek',
        uploaded: 'Uppladdad',
        createdBy: 'Uppladdad av',
        latitude: 'Latitude',
        longitude: 'Longitude',
      },
    },
    toast: {
      create: 'Progress-rapport skapad för HP',
      update: 'Progress-rapport updaterad för HP',
      duplicateFileName: 'Duplicerat filnamn! För fil ',
      delete: 'Progress-rapport raderad',
    },
  },
  placmentImageLink: {
    title: 'Öppna instruktionsbild i ny flik',
  },
  imagePreview: {
    header: 'Förhandsvisning',
    upload: 'Ladda upp',
    cancel: 'Avbryt',
    noImages: 'Tryck för att bifoga',
    loadingImages: 'Laddar...',
  },
  imagePreviewV2: {
    preview: 'Förhandsvisning',
    addImages: 'Lägg till bilder',
    close: 'Stäng',
    downloadAll: 'Ladda ner alla',
    editImages: 'Redigera bilder',
    manageImages: 'Hantera bilder',
    done: 'Klar',
    deleteImageQuestion: 'Ta bort bild?',
    confirmDelete: 'Ja, ta bort',
    cancel: 'Avbryt',
    confirmDeleteText: 'Är du säker på att du vill radera denna bild?',
    pleaseWait: 'Vänligen vänta...',
    download: 'Ladda ner',
    images: 'Bilder',
    imageDeleted: 'Bild borttagen',
    saved: 'Sparat!',
    uploaded: 'Uppladdad',
    noImagesAvailable: 'Inga bilder tillgängliga',
    addImagesBelow: 'Du kan lägga till bilder nedan!',
  },
  macAddressInvalid: 'Felaktig MAC-adress',
  Huvudbyggnad: 'Huvudbyggnad',
  Extraanslutning_seperat_byggnad: 'Extraanslutning seperat byggnad',
  Extraanslutning_inom_huvudbyggnad: 'Extraanslutning inom huvudbyggnad',
  searchComponent: {
    placeholder: 'Sök efter adress eller objektnamn',
  },
  workSectionStatus: {
    EXECUTED: 'Utförd',
    PLANNED: 'Planerad',
    AWAITING_PLANNING: 'Inväntar planering',
    INCOMPLETE: 'Ej fullständig',
  },
  workSectionStatusTooltip: {
    EXECUTED: 'Arbetet har slutförts',
    PLANNED: 'Arbetet har planerats men inte slutförts än',
    AWAITING_PLANNING: 'Arbetet har inte planerats än',
    INCOMPLETE: 'Utförd med ofullständiga egenkontroller',
  },
  ductConnectionStatus: {
    NOT_CONNECTED: 'Ej kopplad',
  },
  fileUpload: {
    error: 'Filerna kunde inte laddas upp',
    loadingImages: 'Laddar bilder...',
  },
  select: 'Välj ',
  tableFilter: {
    orderFilterssSectionHeader: ' valda filter',
    addFilterButton: 'Lägg till filter',
    applyFilterButton: 'Använd filter',
    clearAllFiltersButton: 'Rensa alla filter',
    noFilteredOrders: 'Inga beställningar hittades.',
    accessId: {
      existing: 'NetAdmin ID - Befintlig',
      notExisting: 'NetAdmin ID - Obefintlig',
    },
    plotDesign: {
      planned: 'Projektering - Planerad',
      awaitingPlanning: 'Projektering - Inväntar planering',
      executed: 'Projektering - Utförd',
    },
    preinstallation: {
      planned: 'Installation - Planerad',
      awaitingPlanning: 'Installation - Inväntar planering',
      executed: 'Installation - Utförd',
    },
    plotExcavation: {
      planned: 'Tomtschakt - Planerad',
      awaitingPlanning: 'Tomtschakt - Inväntar planering',
      executed: 'Tomtschakt - Utförd',
    },
    ductConnection: {
      connected: 'Dukt Koppling - Kopplad',
      notConnected: 'Dukt Koppling - Ej Kopplad',
    },
    cableBlowing: {
      planned: 'Fiberblåsning - Planerad',
      awaitingPlanning: 'Fiberblåsning - Inväntar planering',
      executed: 'Fiberblåsning - Utförd',
    },
    measuring: {
      planned: 'Skarv & OTDR - Planerad',
      awaitingPlanning: 'Skarv & OTDR - Inväntar planering',
      executed: 'Skarv & OTDR - Utförd',
    },
    commission: {
      planned: 'Driftsättning - Planerad',
      awaitingPlanning: 'Driftsättning - Inväntar planering',
      executed: 'Driftsättning - Utförd',
    },
    perPage: 'Visa per sida: ',
  },
  multiPointModal: {
    header: {
      hp: 'Multi-HP',
      hc: 'Multi-HC',
      well: 'Multi-Brunn',
      household: 'Multi-HC/HP',
    },
    tabs: {
      hp: 'HP',
      hc: 'HC',
      well: 'Brunn',
    },
    closeBtn: 'Stäng',
  },
  feedbackAlert: {
    upload: {
      fileSuccess: 'Fil(er) uppladdade',
      success: 'Bild(er) uppladdade',
      error: 'Misslyckades. Försök igen',
      tooLarge: 'Filen är för stor (max 15MB).',
    },
    undoSelfInspection: {
      success: 'Egenkontroll Ångrad',
      error: 'Misslyckades. Försök igen',
    },
    markAsNA: {
      success: 'Markerad som N/A',
      error: 'Misslyckades. Försök igen',
    },
    save: {
      success: 'Sparat',
      error: 'Misslyckades. Försök igen',
      spanAlreadyPartOfReport: 'Stråk finns redan i en annan rapport',
    },
    remove: {
      success: 'Borttagen',
      error: 'Misslyckades. Försök igen',
    },
  },
  reportStatus: {
    DONE_WITH_DEVIATION: 'Klar med avvikelse',
    UNKNOWN: 'Okänd',
    DONE_WITHOUT_IMAGES: 'Klar utan bilder',
    NOT_STARTED: 'Ej påbörjad',
    PERMIT_DONE: 'Tillstånd - Godkänt',
    PLACEMENT_OF_SITE_DONE: 'Placering av Site - Klar',
    SITE_INSPECTION_DONE: 'Site inspektion - I drift',
    PLACEMENT_OF_HUB_DONE: 'Placering av HUB - Klar',
    HUB_INSPECTION_DONE: 'HUB inspektion - I drift',
    DONE: 'Klar',
    PLANNED: 'Planerad',
    IN_PROGRESS: 'Pågående',
    RESTORED: 'Återställd',
    SETTING_CABINET_DONE: 'Sättning skåp - Slutförd',
    FIBER_WORK_DONE: 'Fiberarbete - Slutförd',
    MARKING_DONE: 'Märkning - Slutförd',
    SETTING_WELL_DONE: 'Sättning brunn - Slutförd',
    JOINT_BOX_DONE: 'Skarvbox - Slutförd',
    WELL_RESTORATION_DONE: 'Återställning - Slutförd',
  },
  reportInfo: {
    lastUpdatedBy: 'Senast uppdaterad av',
    address: 'Adress',
    objectName: 'Objektnamn',
    status: 'Status',
    deviation: 'Avvikelse',
    reportStatusIcon: 'Statusikon för rapport',
    referenceLabel: {
      SITE: 'Objektnamn',
      HUB: 'Objektnamn',
      HP: 'Adress',
      SPAN: 'Stråk ID',
      CABINET: 'Objektnamn',
      MANHOLE: 'Objektnamn',
    },
    method: 'Metod',
    spanType: 'Typ',
    length: 'Längd',
    meters: 'meter',
    comment: {
      label: 'Kommentar',
      placeholder: 'Skriv något...',
    },
  },
  reportInput: {
    save: 'Spara',
    cancel: 'Avbryt',
    done: 'Klar: ',
    na: 'N/A: ',
    addMore: 'Lägg till fler',
    upload: {
      files: 'Ladda upp filer',
      images: 'Ladda upp bilder',
    },
    viewImages: 'Visa bilder',
    remove: 'Ta bort',
    download: 'Ladda ner',
    markAsDone: 'Markera som klar',
    description: 'Beskrivning',
    instructionImage: 'Öppna instruktion',
    optionsButton: {
      markAsNA: 'Markera som ej applicerbar',
      editDescription: 'Redigera beskrivning',
      uploadImages: 'Ladda upp bilder',
      undo: 'Ångra egenkontroll',
    },
    errorPreventionModal: {
      undoSelfInspectionQuestion: 'Ångra egenkontroll?',
      undoSelfInspection: 'Ångra egenkontroll',
      cancel: 'Avbryt',
      text: 'All information och bilder kommer att tas bort om du ångrar egenkontroll.',
    },
    noPointReport: 'Markör finns inte i valt IFS',
    noSpanReport: 'Stråk finns inte i valt IFS',
    errorReport:
      'Kunde inte hämta rapporten. Uppdatera eller försök igen senare.',
    text: {
      label: 'Beskriv anledning',
      placeholder: 'Skriv anledning...',
    },
  },
  signingCard: {
    title: 'Signering av Kundprojektering',
    information:
      'Utför alla obligatoriska egenkontroller och ange utfört datum för att aktivera signering.',
    startSigning: 'Börja signering',
    newSigning: 'Ny signering',
  },
  spanAccomodationMethod: {
    unknown: 'Okänd',
    direct: 'Direkt förlagd',
    softDigging: 'Grävsugning',
    hammarDrilling: 'Hammarborrning',
    groundRocket: 'Jordraket',
    chainDigging: 'Kedjegrävning',
    microTrenching: 'Mikrotrenching',
    plowing: 'Plöjning',
    slotting: 'Spårfräsning',
    guidedDrilling: 'Styrd borrning',
    pressing: 'Tryckning',
    moving: 'Schaktning',
    manualMoving: 'Handschaktning',
    clamping: 'Klamring',
    clampingOnRock: 'Klamring på berg',
    clampingOnLadder: 'Klamring på kabelstege',
    existing: 'Befintlig',
  },
  spanAccomodationType: {
    unknown: 'Befintlig',
    ground: 'Mark',
    asphalt: 'Asfalt',
    tunnel: 'Tunnel',
    bridge: 'Bro',
    radioLink: 'Radiolänk',
    air: 'Luft',
    lake: 'Sjö',
    field: 'Åker',
    gravel: 'Grus',
  },
  selectSpanMode: {
    title: 'Välj stråk för rapport',
    editTitle: 'Redigera stråk i rapport',
    subtitle: 'Klicka på de stråk du vill inkludera i rapporten',
    editSubtitle:
      'Klicka på stråk du vill lägga till eller ta bort från rapporten.',
    meters: 'm',
    selectedDistance: 'Vald sträcka',
    cancel: 'Avbryt',
    createReport: 'Skapa rapport',
    updateReport: 'Spara ändringar',
    warningMaxSpanLength: 'Max 200 m tillåtet för flera stråk.',
    help: 'Hjälp',
    spanExistsInOtherReport: 'Stråket tillhör en annan rapport',
    propertySpanCannotBeReported: 'Tomtstråk kan inte rapporteras.',
    existingSpanCannotBeReported: 'Stråk färdigställt i ett annat projekt.',
    helpModal: {
      title: 'Välja stråk',
      spanColorGuide: {
        title: 'Stråkfärg guide',
        colorNames: {
          cyan: 'Cyan',
          black: 'Svart',
          purple: 'Lila',
          green: 'Grön',
          darkGreen: 'Mörkgrön',
          red: 'Röd',
        },
        description: {
          SELECTED: 'Vald & stråk i samma rapport',
          PLANNED: 'Planerad',
          IN_PROGRESS: 'Påbörjad',
          DONE: 'Klar',
          RESTORED: 'Återställd',
          DEVIATED: 'Återställd med avvikelse',
        },
      },
      addingSpans: {
        title: 'Lägga till stråk',
        body: 'Klicka på stråken för att välja dem. Valda och inkluderade stråk markeras i cyan och görs tjockare.',
      },
      removingSpans: {
        title: 'Ta bort stråk',
        body: 'Klicka på ett valt (cyan) stråk för att avmarkera det. Markeringen försvinner och det exkluderas från rapporten.',
      },
      spansNotAllowedForSelection: {
        title: 'Stråk som inte kan väljas',
        body: 'Stråk i andra rapporter kan inte väljas. Ta bort dem från deras nuvarande rapport först. De kan vara i en annan färg eller svarta om de tillhör en planerad rapport.',
      },
    },
  },
  copied: 'Kopierad',
  portConnectionStatus: {
    portConnection: 'Portanslutning',
    noMac: 'Ingen giltig MAC-adress eller serienummer i installation',
    toPreinstallation: 'Gå till installation',
    checkStatus: 'Kontrollera portanslutningens status för beställningen.',
    checkConnection: 'Kontrollera anslutning',
    loadingState: 'Kontrollerar status. Vänligen vänta...',
    linking: 'Länkar',
    notLinking: 'Inte länkad',
    installationDate: 'Installationsdatum: ',
    checkAgain: 'Kontrollera igen',
    debugMessage: 'Vänligen felsök och försök igen.',
  },
};
